import { render, staticRenderFns } from "./Problems.vue?vue&type=template&id=0f221219&"
import script from "./Problems.vue?vue&type=script&lang=js&"
export * from "./Problems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports